'use strict';

/**
 * The core styletron module
 * @packagename styletron-core
 */
var StyletronCore =
/*#__PURE__*/
function () {
  /**
   * Create a new StyletronCore instance
   * @param {object} [opts]           An object containing options
   * @param {string} [opts.prefix=''] A prefix for generated CSS class names
   */
  function StyletronCore(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === void 0 ? '' : _ref$prefix;

    this.cache = {
      media: {},
      pseudo: {}
    };
    this.prefix = prefix === '' ? false : prefix;
    this.uniqueCount = 0;
    this.offset = 10; // skip 0-9

    this.msb = 35;
    this.power = 1;
  }

  StyletronCore.assignDecl = function assignDecl(target, decl, className) {
    var block = decl.block,
        media = decl.media,
        pseudo = decl.pseudo;
    var targetEntry;

    if (media) {
      if (!target.media[media]) {
        target.media[media] = {
          pseudo: {}
        };
      }

      targetEntry = target.media[media];
    } else {
      targetEntry = target;
    }

    if (pseudo) {
      if (!targetEntry.pseudo[pseudo]) {
        targetEntry.pseudo[pseudo] = {};
      }

      targetEntry = targetEntry.pseudo[pseudo];
    }

    targetEntry[block] = className;
  };
  /**
   * Injects a declaration (if not already injected) and returns a class name
   * @param  {object} decl          The CSS declaration object
   * @param  {string} decl.prop     The property name
   * @param  {string} decl.val      The property value
   * @param  {string} [decl.media]  The media query
   * @param  {string} [decl.pseudo] The pseudo selector
   * @return {string|undefined}     The class name for the declaration
   */


  var _proto = StyletronCore.prototype;

  _proto.injectDeclaration = function injectDeclaration(_ref2) {
    var prop = _ref2.prop,
        val = _ref2.val,
        media = _ref2.media,
        pseudo = _ref2.pseudo;
    return this.injectRawDeclaration({
      block: prop + ":" + val,
      media: media,
      pseudo: pseudo
    });
  };
  /**
   * Injects a raw declaration (if not already injected) and returns a class name
   * @param  {object} decl          The CSS declaration object
   * @param  {string} decl.block    The declaration block
   * @param  {string} [decl.media]  The media query
   * @param  {string} [decl.pseudo] The pseudo selector
   * @return {string|undefined}     The class name for the declaration
   */


  _proto.injectRawDeclaration = function injectRawDeclaration(decl) {
    var cached = this.getCachedDeclaration(decl);

    if (cached) {
      return cached;
    }

    var virtualCount = this.incrementVirtualCount();
    var hash = virtualCount.toString(36);
    var className = this.prefix ? this.prefix + hash : hash;
    StyletronCore.assignDecl(this.cache, decl, className);
    return className;
  };
  /**
   * Get the next virtual class number, while setting
   * the uniqueCount, offset, and msb counters appropriately.
   * @return {number} The virtual class count
   * @private
   */


  _proto.incrementVirtualCount = function incrementVirtualCount() {
    var virtualCount = this.uniqueCount + this.offset;

    if (virtualCount === this.msb) {
      this.offset += (this.msb + 1) * 9;
      this.msb = Math.pow(36, ++this.power) - 1;
    }

    this.uniqueCount++;
    return virtualCount;
  };
  /**
   * Gets the class name for an already injected declaration
   * @param  {object} decl          The CSS declaration object
   * @param  {string} decl.block    The declaration block
   * @param  {string} [decl.media]  The media query
   * @param  {string} [decl.pseudo] The pseudo selector
   * @return {string|undefined}     The class name for the declaration
   * @private
   */


  _proto.getCachedDeclaration = function getCachedDeclaration(_ref3) {
    var block = _ref3.block,
        media = _ref3.media,
        pseudo = _ref3.pseudo;
    var entry;

    if (media) {
      entry = this.cache.media[media];

      if (!entry) {
        return false;
      }
    } else {
      entry = this.cache;
    }

    if (pseudo) {
      entry = entry.pseudo[pseudo];

      if (!entry) {
        return false;
      }
    }

    return entry[block];
  };

  return StyletronCore;
}();

module.exports = StyletronCore;
//# sourceMappingURL=browser.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./~/styletron-core/dist/browser.es5.js
// module id = 549
// module chunks = 231608221292675